import { SubscriberStatus } from '@wui/im'

type CallStatusDoNotDisturbSnapshot = {
  isChangedByCall: boolean
  oldStatusText: string
}

type ManualStatusPayload = {
  status: SubscriberStatus
  text?: string
}

export const resolveManualStatusChange = (
  status: SubscriberStatus,
  callStatus: CallStatusDoNotDisturbSnapshot,
): {
  payload: ManualStatusPayload
  shouldClearChangedByCall: boolean
} => {
  const shouldRestoreCallStatusText = callStatus.isChangedByCall
    && status !== SubscriberStatus.DO_NOT_DISTURB

  return {
    payload: {
      status,
      ...(shouldRestoreCallStatusText
        ? { text: callStatus.oldStatusText }
        : {}),
    },
    shouldClearChangedByCall: status === SubscriberStatus.DO_NOT_DISTURB || shouldRestoreCallStatusText,
  }
}
